<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="billingLoading" persistent max-width="200" attach="body" content-class="billing-loading-dialog">
            <v-card color="transparent" flat>
                <v-card-text class="text-center">
                    <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                    <div class="mt-3">Generating Billing PDF...</div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs4>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>
  
                    </v-btn>
                </v-flex>
  
                <!-- <v-flex xs12 md1 class="mb-2">
                  <v-btn
                      fab
                      small
                      @click="printTable()"
                      class="ml-8 white--text"
                      color="#2b6993"
                      elevation="4"
                      absolute
                      right
                      >
                      <v-icon>print</v-icon>
                  </v-btn>
                </v-flex> -->
  
                <v-flex xs12>
                    <h3 class="text-center mb-5">Case Management Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>
  
                <v-flex xs12>
                    <v-card
                        class="ma-3 pa-3"
                        elevation="0"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 md2 class="pa-1">
                                <v-menu
                                    ref="calendarMenu"
                                    v-model="calendarMenu"
                                    :return-value.sync="startDate"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="startDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="startDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'
                                        @change="saveStartDate"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendarMenu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
  
                            </v-flex>
  
                            <v-flex xs12 md2 class="pa-1 hideOnPrint">
                                <v-menu
                                    ref="calendar2Menu"
                                    v-model="calendar2Menu"
                                    :return-value.sync="endDate"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="endDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="endDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'
                                        @change="saveEndDate"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendar2Menu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
  
                            <v-flex xs12 md2 class="pa-1 mb-2 hideOnPrint">
                                <v-select
                                    label="Select a Client"
                                    :items="clients"
                                    item-text="Name"
                                    item-value="_id"
                                    v-model="clientID"
                                    clearable
                                    :required="requiredField"
                                ></v-select>
                            </v-flex>
  
                            <v-flex xs12 md2 class="pa-1 mb-2 hideOnPrint">
                                <v-select
                                    label="Filter by Level"
                                    :items="levelFilterOptions"
                                    v-model="selectedLevelFilter"
                                    clearable
                                ></v-select>
                            </v-flex>
  
                            <v-flex xs12 md4 class="mt-5 mb-5 pl-5">
                                <!-- <v-btn
                                  fab
                                  small
                                  @click="printTable()"
                                  class="mr-8 mb-2 white--text"
                                  color="#2b6993"
                                  elevation="4"
                                  >
                                  <v-icon>print</v-icon>
                              </v-btn> -->
  
                                <v-btn
                                    small
                                    @click="getQueryData()"
                                    class="ma-1"
  
                                >Search
                                </v-btn>
  
                                <v-btn
                                    small
                                    @click="generatePDF()"
                                    class="ma-1"
                                    v-if="canExport"
                                >Generate Billing</v-btn>
  
                               
  
  
                                <!-- <v-menu offset-y>
                                  <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                      class="white--text"
                                      v-bind="attrs"
                                      v-on="on"
                                      color="blue-grey"
                                      small
                                      :loading="isDownloading"
                                      :disabled="isDownloading"
                                    >
                                      Export
                                      <v-icon right dark> mdi-cloud-download </v-icon>
                                    </v-btn>
                                  </template>
  
                                  <v-list class="pa-0">
                                    <v-list-item
                                      v-for="(item, index) in reportItems"
                                      :key="index"
                                      link
                                    >
                                      <v-list-item-title
                                        v-text="item"
                                        @click="print(item)"
                                      ></v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu> -->
  
                                <v-dialog v-model="dialog" max-width="100%">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="#2b3990" small dark v-on="on" @click="showAdd()"
                                        >
                                            <v-icon left>add</v-icon>
                                            Add Case Management
                                        </v-btn
                                        >
                                    </template>
                                    <v-card>
                                        <v-card-title style="background-color: #2b3990">
                                            <span class="headline white--text">{{ titleForm }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-form
                                                ref="form"
                                                lazy-validation
                                            >
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" v-if="newCase">
                                                            <v-select
                                                                label="Select Clients"
                                                                :items="clients"
                                                                v-model="newClients"
                                                                item-text="Name"
                                                                item-value="_id"
                                                                :rules="requiredField"
                                                                multiple
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" v-if="editCase">
                                                            <v-select
                                                                label="Client"
                                                                :items="clients"
                                                                v-model="newClients"
                                                                item-text="Name"
                                                                item-value="_id"
                                                                :rules="requiredField"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" md="4">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="menu"
                                                                :close-on-content-click="false"
                                                                :return-value.sync="date"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        v-model="newDate"
                                                                        label="Date of Service"
                                                                        prepend-icon="mdi-calendar"
                                                                        readonly
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        :rules="requiredField"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="newDate"
                                                                    no-title
                                                                    scrollable
                                                                >
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        text
                                                                        color="primary"
                                                                        @click="menu = false"
                                                                    >
                                                                        Cancel
                                                                    </v-btn>
                                                                    <v-btn
                                                                        text
                                                                        color="primary"
                                                                        @click="$refs.menu.save(newDate)"
                                                                    >
                                                                        OK
                                                                    </v-btn>
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="12" md="4">
                                                            <v-select
                                                                :items="times"
                                                                label="Duration of Service Provided"
                                                                v-model="newTime"
                                                                :rules="requiredField"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" md="4">
                                                            <v-select
                                                                label="Select Location"
                                                                :items="locations"
                                                                v-model="newLocation"
                                                                item-text="displayText"
                                                                item-value="letter"
                                                                :rules="requiredField"
                                                            ></v-select>
                                                        </v-col>
  
                                                        <v-col cols="12">
                                                            <v-radio-group
                                                                v-model="newLevel"
                                                            >
                                                                <v-radio   
                                                                    label="Bachelor's Level"
                                                                    value="Bachelor's Level"
                                                                ></v-radio>
                                                                <v-radio   
                                                                    label="Non-Bachelor's Level"
                                                                    value="Non-Bachelor's Level"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-col>
  
                                                        <v-col cols="12">
                                                            <v-select
                                                                label="Select Code"
                                                                :items="codes"
                                                                v-model="newCode"
                                                                item-text="displayText"
                                                                item-value="number"
                                                                :rules="requiredField"
                                                            ></v-select>
                                                        </v-col>
  
                                                        <v-col cols="12">
                                                            <v-textarea
                                                                label="Add Service Provided Description"
                                                                v-model="newServiceProvided"
                                                                :rules="requiredField"
                                                                outlined
                                                                maxlength="75"
                                                                counter
                                                            ></v-textarea>
                                                        </v-col>
  
                                                        <v-col cols="12" sm="12">
                                                            <v-checkbox
                                                                label="Staff Signature"
                                                                v-model="staffSignature"
                                                                @click="addStaffSignature()"
                                                                :rules='requiredField'
                                                            ></v-checkbox>
                                                        </v-col>
  
                                                        <v-col class="d-flex" cols="12" sm="12">
                                                            <v-text-field 
                                                                v-if="staffSignature"
                                                                v-model="newStaffSignature" 
                                                                label="Signed By" 
                                                                readonly>
                                                            </v-text-field>
                                                        </v-col>
  
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                        </v-card-text>
  
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                class="white--text"
                                                color="#259647"
                                                @click="addCase()"
                                                v-if="newCase"
                                            >Save
                                            </v-btn
                                            >
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="updateCase()"
                                                v-if="editCase"
                                            >Update
                                            </v-btn
                                            >
                                            <v-btn color="blue darken-1" text @click="close"
                                            >Cancel
                                            </v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
  
  
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    v-if="canExport"
                                    v-model="excludeNonBachelor"
                                    label="Exclude Non-Bachelor Hours from Billing Report"
                                    class="ma-1"
                                    hide-details
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
  
  
                <v-flex xs12 class="pa-2 hideOnPrint">
                    <div v-if="!hasSearched" class="text-center pa-4">
                        <v-icon size="64" color="grey lighten-1">mdi-magnify</v-icon>
                        <h3 class="grey--text text--darken-1 mt-2">No data to display</h3>
                        <p class="grey--text">Please select your search criteria and click "Search" to view case management entries.</p>
                    </div>
                    <v-data-table
                        v-else
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                        :headers="headers"
                        :items="filteredCases"
                        sort-by="Date"
                        sort-desc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Case Management"
                        :items-per-page="100"
  
                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn
                                x-small
                                class="white--text ma-1"
                                color="#2b3990"
                                @click="viewCase(item)"
                            >
                                view
                            </v-btn>
                            <v-btn
                                x-small
                                class="error"
                                @click="deleteCase(item)"
                            >
                                delete
                            </v-btn>
                        </template>
                        
                        <template v-slot:footer>
                            <v-row v-if="hasSearched && cases.length > 0" class="pa-3">
                                <v-col cols="12" class="text-left">
                                    <v-chip
                                        color="success"
                                        text-color="white"
                                        class="ma-1"
                                    >
                                        <v-icon left small>mdi-clock</v-icon>
                                        Total Hours: {{ totalHours.toFixed(2) }}
                                    </v-chip>
                                    <v-chip
                                        color="primary"
                                        text-color="white"
                                        class="ma-1"
                                    >
                                        <v-icon left small>mdi-school</v-icon>
                                        Bachelor: {{ bachelorHours.toFixed(2) }}
                                    </v-chip>
                                    <v-chip
                                        color="warning"
                                        text-color="white"
                                        class="ma-1"
                                    >
                                        <v-icon left small>mdi-account</v-icon>
                                        Non-Bachelor: {{ nonBachelorHours.toFixed(2) }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>
  
                </v-flex>
            </v-layout>
        </v-card>
        <div id="printTable">
            <h2 class="text-center">Case Management Report</h2>
            <v-row row wrap>
                <v-col cols="4">
                    <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        :rules='requiredField'
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        :rules='requiredField'
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-select
                        label="Select a Client"
                        :items="clients"
                        item-text="Name"
                        item-value="_id"
                        v-model="clientID"
                        clearable
                        :rules="requiredField"
                    ></v-select>
                </v-col>
                <v-col cols='12'>
  
                    <v-data-table
                        :headers="headers"
                        :items="cases"
                        sort-by="Date"
                        sort-desc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Case Management"
                        :items-per-page="-1"
  
                    >
                        <!-- <template v-slot:item.select="{ item }">
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewMAR(item)"
                            >
                                view
                            </v-btn>
                        </template> -->
                    </v-data-table>
  
                </v-col>
            </v-row>
            <v-dialog v-model="reportDialog">
                <v-card>
                    <v-card-title>Report Information</v-card-title>
                    <v-card-text>
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Authorized Hours"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Hours Billed"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-radio-group
                                            label=""
                                        >
                                            <v-radio
                                                label="Urban"
                                                value="Urban"
                                            ></v-radio>
                                            <v-radio
                                                label="Rural"
                                                value="Rural"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="generatePDF()">Generate Report</v-btn>
                        <v-btn text @click="closeReportDialog()">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
  
            </v-dialog>
        </div>
        <v-dialog v-model="signatureDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Select Signatures</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    v-model="selectedRSM1"
                                    :items="users"
                                    item-text="Name"
                                    return-object
                                    label="First RSM*"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    v-model="selectedRSM2"
                                    :items="users"
                                    item-text="Name"
                                    return-object
                                    label="Second RSM (Optional)"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    v-model="selectedQIDP"
                                    :items="users"
                                    item-text="Name"
                                    return-object
                                    label="QIDP*"
                                    required
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="signatureDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="handleSignatureSubmit">
                        Generate PDF
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
  </template>
  <script>
  import axios from 'axios'
  import {mapActions} from 'vuex';
  import momentTz from 'moment-timezone';
  import Swal from "sweetalert2";
  
  const url = require("../../client_config/config").url;
  
  export default {
    name: 'CaseManagement',
    components: {},
    data: () => ({
        headers: [
            {
                text: "Date",
                align: "start",
                value: "Date",
            },
            {text: "Client", value: "ClientName"},
            {text: "Time", value: "Time"},
            {text: "Code", value: "Code"},
            {text: "Location", value: "Location"},
            {text: "Actions", value: "actions", sortable: false},
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        startDate: "",
        endDate: "",
        menu: false,
        calendarMenu: false,
        calendar2Menu: false,
        dialog: false,
        reportDialog: false,
        signatureDialog: false,
        selectedRSM1: null,
        selectedRSM2: null,
        selectedQIDP: null,
        users: [],
        editCase: false,
        newCase: false,
        msg: false,
        search: "",
        text: "",
        cases: [],
        tempData: [],
        clients: [],
        clientID: "",
        titleForm: "New Case Management",
        caseManagementID: "",
        newDate: "",
        newTime: "",
        newCode: null,
        newLocation: null,
        newLevel: "",
        newServiceProvided: "",
        staffSignature: false,
        newStaffSignature: "",
        userID: localStorage.getItem('userID'),
        staff: localStorage.getItem('Name'),
        codes: [
            {number: "1", description: "Assist person to develop personal goals."},
            {number: "2", description: "Schedule/attend PCP meeting and other informational meetings."},
            {
                number: "3",
                description: "Develop Habilitation/Support Plans & train staff on plans and data collection."
            },
            {
                number: "4",
                description: "Assist person to apply for and obtain community resources and benefits (e.g.: housing; food stamps, Medicaid, etc.)"
            },
            {number: "5", description: "Assist person to locate residence."},
            {
                number: "6",
                description: "Assist in arranging and managing generic community resources and informal supports."
            },
            {
                number: "7",
                description: "Assist in identifying and sustaining natural support networks, network of family, friends and associates."
            },
            {number: "8", description: "Provide problem solving and support with crisis management."},
            {
                number: "9",
                description: "Support person with budgeting, bill paying and with scheduling and keeping appointments."
            },
            {
                number: "10",
                description: "Observe, coach, train and provide feedback of waiver services provided by direct & support services staff."
            },
            {number: "11", description: "Follow-up with Health/Welfare concerns and remediation with deficiencies."},
            {number: "12", description: "Complete required paperwork on behalf of the person served."},
            {
                number: "13",
                description: "Make home visits to observe the person's living environment to assure health, and welfare"
            },
            {
                number: "14",
                description: "Provide information to Service Coordinator to allow for evaluation and assurance of support services provided in PCP."
            },
  
        ].map(code => ({
            ...code,
            displayText: `${code.number}. ${code.description}`, // Combine for display
        })),
        locations: [
            {letter: "H", description: "Home"},
            {letter: "O", description: "Office"},
            {letter: "W", description: "Work"},
            {letter: "S", description: "School"},
            {letter: "P", description: "Phone"},
            {letter: "T", description: "Other"},
  
        ].map(location => ({
            ...location,
            displayText: `${location.letter} - ${location.description}`, // Combine for display
        })),
        times: [
            ".25",
            ".50",
            ".75",
            "1.00",
            "1.25",
            "1.50",
            "1.75",
            "2.00",
            "2.25",
            "2.50",
            "2.75",
            "3.00",
            "3.25",
            "3.50",
            "3.75",
            "4.00",
            "4.25",
            "4.50",
            "4.75",
            "5.00",
            "5.25",
            "5.50",
            "5.75",
            "6.00",
            "6.25",
            "6.50",
            "6.75",
            "7.00",
            "7.25",
            "7.50",
            "7.75",
            "8.00",
            "8.25",
            "8.50",
            "8.75",
            "9.00",
            "9.25",
            "9.50",
            "9.75",
            "10.00",
  
        ],
        requiredField: [
            v => !!v || 'This is required',
        ],
        isLoading: false,
        isDownloading: false,
        userState: localStorage.getItem('userState'),
        reportItems: ['PDF'],
        newClients: [],
        companyID: localStorage.getItem('userCompanies'),
        page: 1,
        pageCount: 1,
        itemCount: 0,
        options: {},
        billingLoading: false,
        hasSearched: false,
        levelFilterOptions: [
            { text: 'Bachelor\'s Level', value: 'Bachelor\'s Level' },
            { text: 'Non-Bachelor\'s Level', value: 'Non-Bachelor\'s Level' },
        ],
        selectedLevelFilter: null,
        excludeNonBachelor: false,
    }),
  
    computed: {
        canExport() {
            return this.startDate && this.endDate && this.clientID != '' && this.cases.length > 0;
        },
        totalHours() {
            if (!this.cases || this.cases.length === 0) {
                return 0;
            }
            
            return this.cases.reduce((total, caseItem) => {
                let time = 0;
                
                // Handle different time formats
                if (caseItem.Time) {
                    // If it's already a number
                    if (typeof caseItem.Time === 'number') {
                        time = caseItem.Time;
                    } else {
                        // If it's a string, try to parse it
                        const parsedTime = parseFloat(caseItem.Time);
                        time = isNaN(parsedTime) ? 0 : parsedTime;
                    }
                }
                
                return total + time;
            }, 0);
        },
        filteredCases() {
            if (!this.cases || this.cases.length === 0) {
                return [];
            }
            
            if (!this.selectedLevelFilter) {
                return this.cases;
            }
            
            return this.cases.filter(caseItem => caseItem.Level === this.selectedLevelFilter);
        },
        bachelorHours() {
            if (!this.cases || this.cases.length === 0) {
                return 0;
            }
            
            return this.cases.reduce((total, caseItem) => {
                if (caseItem.Level === "Bachelor's Level") {
                    let time = 0;
                    if (caseItem.Time) {
                        if (typeof caseItem.Time === 'number') {
                            time = caseItem.Time;
                        } else {
                            const parsedTime = parseFloat(caseItem.Time);
                            time = isNaN(parsedTime) ? 0 : parsedTime;
                        }
                    }
                    return total + time;
                }
                return total;
            }, 0);
        },
        nonBachelorHours() {
            if (!this.cases || this.cases.length === 0) {
                return 0;
            }
            
            return this.cases.reduce((total, caseItem) => {
                if (caseItem.Level === "Non-Bachelor's Level") {
                    let time = 0;
                    if (caseItem.Time) {
                        if (typeof caseItem.Time === 'number') {
                            time = caseItem.Time;
                        } else {
                            const parsedTime = parseFloat(caseItem.Time);
                            time = isNaN(parsedTime) ? 0 : parsedTime;
                        }
                    }
                    return total + time;
                }
                return total;
            }, 0);
        }
    },
  
    watch: {
        options: {
             handler() {
                 if (this.hasSearched) {
                     this.getQueryData();
                 }
             },
             deep: true
        }
    },
  
    created() {
        this.getClients();
        this.fetchUsers();
    },
  
    methods: {
        ...mapActions({
            downloadCaseManagementReport: "caseManagement/downloadCaseManagementReport"
        }),
        initialize() {
            this.clients = [];
        },
  
        validateDates() {
            if (!this.startDate || !this.endDate) {
                this.showError('Please select both start and end dates');
                return false;
            }
  
            const startYearMonth = this.startDate.slice(0, 7); // YYYY-MM
            const endYearMonth = this.endDate.slice(0, 7);
  
            if (startYearMonth !== endYearMonth) {
                this.showError('Start and end dates must be within the same month');
                return false;
            }
  
            return true;
        },
  
        validate() {
            return this.$refs.form.validate();
        },
  
        updateList() {
            console.log(this.newClients)
        },
  
        getClients() {
            if (this.userState) {
                return axios.get(`${url}/clients/status/state/nevada/active`).then(async res => {
                    this.clients = res.data.clients;
                });
            }
  
            // axios.get(`${url}/clients/`).then(async res => {
            //     this.clients = res.data.clients;
            //   });
        },
  
        clear() {
            this.newDate = "";
            this.newTime = "";
            this.newCode = "";
            this.newLocation = "";
            this.newServiceProvided = "";
            this.newLevel = "";
            this.newStaffSignature = "";
            this.staffSignature = false;
            this.newClients = []
        },
  
  
        close() {
            this.clear()
            this.dialog = false;
  
        },
  
        async generatePDF() {
            try {
                if (!this.validateDates()) {
                    this.showError('Start and end dates must be within the same month');
                    return;
                }
  
                // Show signature dialog
                this.openSignatureDialog();
            } catch (error) {
                console.error('Error generating PDF:', error);
                this.showError('Failed to generate PDF. Please try again.');
            }
        },
        
        openReportDialog(){
            this.reportDialog = true
        },
        closeReportDialog(){
            this.reportDialog = false
        },
  
        getCases: function () {
            this.isLoading = true;
            this.cases = [];
            axios.get(`${url}/caseManagement`).then(res => {
                this.cases = res.data.cases
            })
                .finally(() => (this.isLoading = false));
        },
  
  
        getQueryData() {
            this.cases = []
            this.isLoading = true
            this.hasSearched = true;
  
            let {page, itemsPerPage, sortBy, sortDesc} = this.options;
            page = page || 1;
            itemsPerPage = itemsPerPage || 100;
  
  
            this.startDate = this.startDate || '';
            this.endDate = this.endDate || '';
            this.ClientID = this.ClientID || '';
  
            const params = {
                page: page,
                limit: itemsPerPage,
                startDate: this.startDate,
                endDate: this.endDate,
                clientID: this.clientID,
                sortField: Array.isArray(sortBy) && sortBy.length > 0 ? sortBy[0] : 'Date',
                sortDirection: Array.isArray(sortDesc) && sortDesc.length > 0 && sortDesc[0] ? 'desc' : 'asc',
            }
  
            axios.get(`${url}/caseManagement/reports`, {params})
                .then(response => {
                    const {docs, totalPages, totalDocs} = response.data;
  
                    this.cases = docs;
                    this.pageCount = totalPages;
                    this.itemCount = totalDocs;
  
                }).finally(() => {
                this.isLoading = false;
            })
  
            // if(this.clientID == '' || this.clientID == null){
            //   axios.get(`${url}/caseManagement/report/${this.startDate}/${this.endDate}`).then(res => {
            //     this.cases = res.data.cases
            //   })
            //   .finally(() => (this.isLoading = false));
            //
            // } else {
            //   axios.get(`${url}/caseManagement/reports/${this.startDate}/${this.endDate}/${this.clientID}`).then(res => {
            //     this.cases = res.data.cases
            //
            //   })
            //   .finally(() => (this.isLoading = false));
            // }
  
        },
  
        async downloadCaseManagementPDF() {
            this.isDownloading = true
            const startDate = new Date(`${this.startDate}`).toISOString()
            const endDate = new Date(`${this.endDate}`).toISOString()
            const tz = momentTz.tz.guess();
  
            const data = {
                startDate,
                endDate,
                clientId: this.clientID,
                tz
            }
            try {
                const response = await this.downloadCaseManagementReport(data)
                if (response.status === 400) {
                    this.isDownloading = false
                    return alert('Unable to download report')
                }
                const blob = new Blob([response.data], {type: 'application/pdf'})
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'case-management-report.pdf')
                document.body.appendChild(link)
                link.click()
                this.isDownloading = false
            } catch (error) {
                this.isDownloading = false
                console.log(error)
            }
  
        },
  
        download() {
            if (this.startDate == '' || this.startDate == null
                && this.endDate == '' || this.endDate == null) {
                this.msg = true;
                this.text = "Please add start date and end date to download report"
            } else if (this.endDate == '' || this.endDate == null) {
                this.msg = true;
                this.text = "Please add an end date to download report"
  
            } else {
                this.downloadCaseManagementPDF()
            }
        },
  
        print() {
            Swal.fire({
                title: "Print in Progress",
                text: "Please wait while the PDF is being generated and processed. This may take a while if some images or files are attached.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
  
            fetch(`${url}/caseManagement/generate/pdf/${this.startDate}/${this.endDate}/${this.clientID}`)
                .then((response) => response.blob())
                .then((blob) => {
                    const blobUrl = URL.createObjectURL(blob);
                    const printWindow = window.open(blobUrl);
  
                    printWindow.onload = function () {
                        Swal.close();
                        printWindow.print();
                        URL.revokeObjectURL(blobUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating or printing the PDF:", error);
                    Swal.fire("Error", "Failed to generate or print the PDF", "error");
                });
        },
  
        updateCase() {
            var req_body = {
                Date: this.newDate,
                Time: this.newTime,
                Code: this.newCode,
                Location: this.newLocation,
                ServiceProvided: this.newServiceProvided,
                Level: this.newLevel,
                StaffSignature: this.newStaffSignature,
            };
            axios
                .put(`${url}/caseManagement/${this.caseManagementID}`, req_body)
                .then((response) => {
                    if (this.hasSearched) {
                        this.getQueryData();
                    }
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            alert(data.msg);
                        });
                    }
                    this.clear()
                    this.msg = true;
                    this.text = "The record has been updated successfully.";
                });
            this.close();
        },
  
        getClientID(item) {
            this.client = item.ClientID._id;
            window.localStorage.setItem('clientId', this.client)
            console.log(this.client)
        },
  
        viewCase(item) {
            this.titleForm = "Viewing Case Management Record"
            this.dialog = true;
            this.editCase = true;
            this.newCase = false;
            this.newDate = item.Date;
            this.newTime = item.Time;
            this.newCode = item.Code;
            this.newLocation = item.Location;
            this.newServiceProvided = item.ServiceProvided;
            this.newLevel = item.Level;
            if(item.StaffSignature){
                this.newStaffSignature = item.StaffSignature;
                this.staffSignature = true
            }
            this.newClients = item.ClientID;
            this.caseManagementID = item._id;
        },
  
        showAdd() {
            this.titleForm = "New Case Management";
            this.newCase = true;
            this.editCase = false;
        },
  
        addCase: function () {
            // Parse the string into an array
            const companyIDsArray = JSON.parse(this.companyID);
  
            // Get the first company ID
            const firstCompanyID = companyIDsArray[0];
            if (this.validate()) {
                // Assuming newClients is an array of clients
                const requests = this.newClients.map((client) => {
                    var req_body = {
                        Date: this.newDate,
                        Time: this.newTime,
                        Code: this.newCode,
                        Location: this.newLocation,
                        ServiceProvided: this.newServiceProvided,
                        Level: this.newLevel,
                        StaffSignature: this.newStaffSignature,
                        CompanyID: firstCompanyID,
                        ClientID: client,  // Use _id from client
                    };
  
                    return axios.post(`${url}/caseManagement`, req_body);
                });
  
                // Use Promise.all to wait for all requests to complete
                Promise.all(requests)
                    .then((responses) => {
                        responses.forEach((res) => {
                            if (res.status === 400) {
                                res.json().then((data) => {
                                    this.msg = true;
                                    this.text = data.msg;
                                });
                            }
                        });
                        this.clear();
                        this.msg = true;
                        this.text = "All new records have been added successfully.";
                    })
                    .catch((error) => {
                        // Handle error
                        console.error("Error adding cases:", error);
                    })
                    .finally(() => {
                        this.close();
                    });
            } else {
                this.msg = true;
                this.text = "Please fill out all required fields";
            }
        },
        addStaffSignature() {
            if (!this.newStaffSignature) {
                this.staffSignature = true;
                this.newStaffSignature = this.staff + " - " + new Date();
            } else {
                this.newStaffSignature = ""
                this.staffSignature = false;
            }
  
        },
        deleteCase(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this information?") &&
            this.caseDelete(id);
        },
  
        caseDelete(id) {
            axios.delete(`${url}/caseManagement/${id}`).then((response) => {
                if (this.hasSearched) {
                    this.getQueryData();
                }
                if (response.status === 400) {
                    response.json().then(function (data) {
                        return data.msg;
                    });
                }
                this.msg = true;
                this.text =
                    "The case management record has been deleted successfully.";
            });
        },
  
        printTable() {
  
            window.print()
  
        },
  
        printItem() {
            document.getElementById('printTable').style.display = "none";
  
            window.print()
        },
  
        saveStartDate() {
            this.$refs.calendarMenu.save(this.startDate);
            this.calendarMenu = false;
        },
  
        saveEndDate() {
            this.$refs.calendar2Menu.save(this.endDate);
            this.calendar2Menu = false;
        },
  
        async handleSignatureSubmit() {
            try {
                if (!this.selectedRSM1 || !this.selectedQIDP) {
                    this.showError('Please select at least one RSM and a QIDP');
                    return;
                }
  
                this.billingLoading = true;
  
                const userConfirmed = window.confirm(
                    "By continuing, you acknowledge that you are creating the billing for the month provided and the data can not be edited. Do you want to continue?"
                );
  
                if (!userConfirmed) {
                    this.billingLoading = false;
                    return;
                }
  
                // Debug: Log selected users to verify signature property
                console.log('RSM1:', this.selectedRSM1);
                console.log('RSM2:', this.selectedRSM2);
                console.log('QIDP:', this.selectedQIDP);
  
                // Extract year and month from the startDate
                const startYear = this.startDate.split('-')[0];
                const startYearMonth = this.startDate.slice(0, 7);
                const endYearMonth = this.endDate.slice(0, 7);
  
                if (startYearMonth !== endYearMonth) {
                    alert("Start and end dates must be within the same month.");
                    this.billingLoading = false;
                    return;
                }
  
                const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                const startMonth = parseInt(this.startDate.split('-')[1], 10);
  
                // Prepare signature data with robust fallback for signature property
                const signatureData = {
                    RSM1: JSON.stringify({
                        name: this.selectedRSM1.Name,
                        signature: this.selectedRSM1.Signature || this.selectedRSM1.signature || '',
                        date: new Date().toLocaleDateString(),
                        isBachelor: this.selectedRSM1.BachelorsDegree || false
                    }),
                    RSM2: this.selectedRSM2 ? JSON.stringify({
                        name: this.selectedRSM2.Name,
                        signature: this.selectedRSM2.Signature || this.selectedRSM2.signature || '',
                        date: new Date().toLocaleDateString(),
                        isBachelor: this.selectedRSM2.BachelorsDegree || false
                    }) : '',
                    QIDP: JSON.stringify({
                        name: this.selectedQIDP.Name,
                        signature: this.selectedQIDP.Signature || this.selectedQIDP.signature || '',
                        date: new Date().toLocaleDateString(),
                        isBachelor: this.selectedQIDP.BachelorsDegree || false
                    })
                };
  
                // Generate PDF with signatures
                const response = await axios.post(
                    `${url}/caseManagement/generate/pdf`,
                    {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientID: this.clientID,
                        excludeNonBachelor: this.excludeNonBachelor,
                        ...signatureData
                    },
                    { responseType: 'arraybuffer' }
                );
  
                // Create form data for saving the billing
                const formData = new FormData();
                formData.append('Client', this.clientID);
                formData.append('Month', monthNames[startMonth - 1]);
                formData.append('Year', startYear);
                formData.append('StartDate', this.startDate);
                formData.append('EndDate', this.endDate);
                formData.append('Report', "Case Management Report");
                formData.append('Status', "Incomplete");
                formData.append('CreatedBy', this.staff + " - " + new Date());
                formData.append('RSM1', signatureData.RSM1);
                formData.append('RSM2', signatureData.RSM2);
                formData.append('QIDP', signatureData.QIDP);
  
                const blob = new Blob([response.data], { type: 'application/pdf' });
                formData.append('document', blob, "DS-SLA-01_RSM_Log_v.2.2024_Form.pdf");
  
                // Save the billing
                await axios.post(`${url}/billings/saveBilling`, formData, {
                    headers: {
                        "content-type": "multipart/form-data",
                    },
                });
  
                this.msg = true;
                this.text = "Billing saved successfully. Go to billing report to view.";
                this.signatureDialog = false;
  
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    alert(error.response.data.message);
                } else {
                    console.error("Error during PDF generation or data saving:", error);
                }
            } finally {
                this.billingLoading = false;
            }
        },
  
        showError(message) {
            this.msg = true;
            this.text = message;
        },
  
        async fetchUsers() {
            try {
                const response = await axios.get(`${url}/users`);
                this.users = response.data.users;
            } catch (error) {
                console.error('Error fetching users:', error);
                this.showError('Failed to fetch users. Please try again.');
            }
        },
  
        openSignatureDialog() {
            this.signatureDialog = true;
            this.fetchUsers();
        },
  
        closeSignatureDialog() {
            this.signatureDialog = false;
            this.selectedRSM1 = null;
            this.selectedRSM2 = null;
            this.selectedQIDP = null;
        },
    }
  }
  </script>
  <style>
  @media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
  
  }
  
  #printTable {
    display: none;
  }
  
  #printItem {
    display: none;
  }
  
  @media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
  
  }
  
  @media print {
    #printTable {
        display: block;
        border: none;
        width: 1300px;
        padding-right: 300px;
        margin-left: -200px;
  
    }
  
    .hideOnPrint {
        display: none;
        border: none;
    }
  
    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;
  
    }
  
    @page {
        margin: 0;
    }
  
    body {
        margin: 1.6cm;
    }
  
  
  }
  
  .billing-loading-dialog {
  z-index: 3000 !important;
  }
  </style>